import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contractDayReservableAreasKey } from './useAPIGetContractDayReservableAreas'

import { post } from 'api/apiClient'

type CreateReservationPayload = {
  rentableHierarchyId: number
  starts: 'today' | 'next_month'
}

const createReservation = (
  contractUuid: string,
  payload: CreateReservationPayload
) =>
  post<void>(
    API_ENDPOINTS.CONTRACT_DAY_RESERVABLE_AREA_RESERVATIONS.replace(
      ':contractUuid',
      contractUuid
    ),
    payload,
    z.void()
  )

export const useAPICreateContractDayReservableAreaReservation = (
  contractUuid: string | undefined
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateReservationPayload) => {
      if (!contractUuid) throw new Error('Contract UUID is required')
      return createReservation(contractUuid, payload)
    },
    onSuccess: () => {
      if (contractUuid) {
        queryClient.invalidateQueries({
          queryKey: contractDayReservableAreasKey(contractUuid, 'all'),
        })
        queryClient.invalidateQueries({
          queryKey: contractDayReservableAreasKey(contractUuid, 'own'),
        })
        queryClient.invalidateQueries({
          queryKey: ['extra-service-reservations', contractUuid],
        })
      }
    },
  })
}
